import { Fade, Menu, MenuItem } from '@mui/material'
import React from 'react'
import { ChipButtonModal } from '../../../Models'
import { disableButtonBasedOnRole } from '../../../Helpers/Util'
import CONSTANTS from '../../../Constants'

const ChipButton: React.FC<ChipButtonModal> = ({
  type = 'primary',
  Icon,
  label,
  suffix,
  dropdown,
  options,
  value = 'INACTIVE',
  action,
  style,
  disabled,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = (item: any) => {
    if (action) action(item.type)
    setAnchorEl(null)
  }

  const pathArray = window.location.pathname.split('/')
  const moduleAccess = disableButtonBasedOnRole(pathArray[1])

  const displayIcon = () => {
    if (!Icon) return null
    return (
      <div className='chip__button-icon'>
        <Icon />
      </div>
    )
  }
  const displayLabelAndIcon = () => {
    return (
      <>
        {suffix && displayIcon()}
        <div className='chip__button-text'>{label}</div>
        {!suffix && displayIcon()}
      </>
    )
  }

  return !dropdown && !options ? (
    <div
      className={`chip__button ${type} ${
        ((CONSTANTS.SAVE_CTA_LABELS.some((text) => label.includes(text)) && moduleAccess) ||
          disabled) &&
        'disableBtn'
      }`}
      style={style}
    >
      {displayLabelAndIcon()}
    </div>
  ) : (
    <React.Fragment>
      <div
        className={`chip__button ${type} ${(moduleAccess || disabled) && 'disableBtn'}`}
        id='fade-button'
        data-testid='active__status-dd'
        aria-controls={open ? 'fade-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        onClick={(e) => {
          if (!moduleAccess || !disabled) {
            handleClick(e)
          }
        }}
        style={style}
      >
        {displayLabelAndIcon()}
      </div>
      <Menu
        className='c-active-inactive-dropdown'
        id='fade-menu'
        data-testid='chip__button-menu'
        MenuListProps={{
          'aria-labelledby': 'fade-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        {options
          ?.filter((item) => item.value !== value)
          .map((item) => (
            <MenuItem key={item.label} onClick={() => handleClose(item)}>
              {item.label}
            </MenuItem>
          ))}
      </Menu>
    </React.Fragment>
  )
}
export default ChipButton
